import { render, staticRenderFns } from "./TOPIP.vue?vue&type=template&id=488e91d0&scoped=true"
import script from "./TOPIP.vue?vue&type=script&lang=js"
export * from "./TOPIP.vue?vue&type=script&lang=js"
import style0 from "./TOPIP.vue?vue&type=style&index=0&id=488e91d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e91d0",
  null
  
)

export default component.exports